import { QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";

/** Repete só falhas transitórias (rede/5xx): um 4xx daria o mesmo resultado de novo. */
function shouldRetry(failureCount: number, error: unknown): boolean {
    const status = isAxiosError(error) ? error.response?.status : undefined;
    if (status !== undefined && status >= 400 && status < 500) return false;
    return failureCount < 1;
}

/**
 * Cliente único do TanStack Query.
 *
 * Padrão para novas features (e migração incremental das existentes):
 * dados de servidor entram via useQuery/useMutation com queryKey por domínio
 * (ex.: ["projects", projectId]) em vez de useState + useEffect + axios manual.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,
            retry: shouldRetry,
            refetchOnWindowFocus: false,
        },
    },
});
